import { DynamicObject } from './commonTypes';
import { INBUILT_DATA_TYPES } from './constants/stringConstants';

// Single Play Api Response Validator
export const validateSinglePlayDataResponse = (data: any) => {
  let validated = false;
  if (data && typeof data === 'object' && data.error_code) {
    if (data.error_code === '401') {
      validated = true;
    } else if (
      data.assetDetails &&
      Object.keys(data.assetDetails).length &&
      (data.error_code === '3804' || // no subscription no trailer
        data.error_code === '601' || // adult content needs login
        data.error_code === '603' || // before tv no trailer
        data.error_code === '604' || // tvod content error
        data.error_code === '606' || // parental control error
        data.error_code === '3608' || // device limit error
        data.error_code === '3603' || // concurrency error
        data.error_code === '3609' || // concurrency stream limit
        data.error_code === '3814' ||
        data.error_code === '3614' || // zee5 lite plan error
        data.error_code === '3610' || // mobile only plan
        data.error_code === '3805') // language packs subscription error
    ) {
      validated = true;
    }
  } else if (
    data &&
    typeof data === 'object' &&
    data.entitlement &&
    data.keyOsDetails
  ) {
    if (
      (data.entitlement.isAVOD === 1 ||
        data.entitlement.isLive === 1 ||
        data.entitlement.isPremiumPlayback === 1) &&
      !data.entitlement.isTrailer &&
      data.assetDetails &&
      Object.keys(data.assetDetails).length &&
      ((data.assetDetails.is_drm && data.keyOsDetails.sdrm) ||
        (!data.assetDetails.is_drm && data.keyOsDetails.hls_token) ||
        (data.entitlement.isLive && data.keyOsDetails.video_token))
    ) {
      validated = true;
    } else if (
      data.entitlement.isTrailer === 1 &&
      data.trailerDetails &&
      Object.keys(data.trailerDetails).length &&
      ((data.trailerDetails.is_drm && data.keyOsDetails.sdrm) ||
        (!data.trailerDetails.is_drm && data.keyOsDetails.hls_token))
    ) {
      validated = true;
    }
  }
  return validated;
};

export const validateResponseObject = (data: DynamicObject) => {
  let validated = false;
  if (
    data &&
    typeof data === INBUILT_DATA_TYPES.OBJECT &&
    Object.keys(data).length
  ) {
    validated = true;
  }
  return validated;
};

export const getValidResponseForEpisodes = (response: DynamicObject) => {
  if (
    response &&
    Object.prototype.hasOwnProperty.call(response, 'episodeDetails')
  ) {
    if (validateResponseObject(response.episodeDetails)) {
      return response.episodeDetails;
    }
  } else if (
    response &&
    Object.prototype.hasOwnProperty.call(response, 'video')
  ) {
    if (validateResponseObject(response.video)) {
      return response.video;
    }
  }
};
